import React from "react";
import { Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// eslint-disable-next-line react/prop-types
function DeleteModel({ onClick, show, setShow, showLoader, name = "coupon" }) {
  const handleClose = () => setShow(false);

  return (
    <Modal className="deleteModel" show={show} onHide={handleClose} keyboard={false} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <h6>Are you sure you want to delete {name}?</h6>
        <div className="mt-3 text-end">
          <Button variant="outline-danger" onClick={handleClose} disabled={showLoader}>
            NO
          </Button>
          {showLoader ? (
            <Button className="d-inline-flex text-white fw-bolder align-items-center ml-2" disabled variant="success">
              <p className="mb-0 fw-bolder me-2">Deleting...</p>
              <Spinner animation="border" size="sm" />
            </Button>
          ) : (
            <Button className="ml-2" onClick={onClick} variant="success">
              YES
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteModel;
